/**
 * Links in chat text — the same rule as server/utils/links.js, so whatever the
 * thread draws as a link is exactly what the info panel's Links tab lists.
 *
 * http(s):// or a bare www. host, up to the next whitespace, with trailing
 * sentence punctuation trimmed back off ("see https://x.com." links x.com) and
 * a closing bracket kept only when the link opened one.
 */
const LINK_RE = /\b(?:https?:\/\/|www\.)[^\s<>"]+/gi;

const trimLink = (raw) => {
    let link = raw.replace(/[.,;:!?'"]+$/, '');
    while (link.endsWith(')') && (link.match(/\(/g) || []).length < (link.match(/\)/g) || []).length) {
        link = link.slice(0, -1).replace(/[.,;:!?'"]+$/, '');
    }
    return link;
};

export const hrefFor = (link) => (/^https?:\/\//i.test(link) ? link : `https://${link}`);

/**
 * Split text into alternating plain and link parts: [{ text }, { text, href }].
 * Plain text only — callers render it as text nodes, never as HTML.
 */
export const splitLinks = (text) => {
    if (!text) return [];
    const parts = [];
    let last = 0;
    for (const match of text.matchAll(LINK_RE)) {
        const link = trimLink(match[0]);
        if (!link) continue;
        if (match.index > last) parts.push({ text: text.slice(last, match.index) });
        parts.push({ text: link, href: hrefFor(link) });
        last = match.index + link.length;
    }
    if (last < text.length) parts.push({ text: text.slice(last) });
    return parts;
};
